import { Chart } from "react-google-charts";
import colorArray from "../../../utils/JSON/colorArray";
import { useEffect, useRef } from "react";
import { customTooltipGoogleCharts } from "./customToolTip/CustomToolTip";
import NoDataComponent from "../NoDataComponent";
interface DonutChartProps {
  data: any[]; // Replace 'any[]' with a more specific type if possible
}

const DonutChart: React.FC<DonutChartProps> = ({ data }) => {
  const chartRef = useRef<any>(null);

  if (!data || !data.length) {
    return (
      <div className="h-[80%] pr-1.5 w-full flex justify-center">
        <NoDataComponent />
      </div>
    );
  }

  return (
    <div className="h-[83%] md:ml-0 ml-[-15px]">
      <Chart
        ref={chartRef}
        width={"auto"}
        height={"100%"}
        chartType="PieChart"
        loader={<div>Loading Chart</div>}
        data={[
          [
            "Task",
            "Hours per Day",
            { type: "string", role: "tooltip", p: { html: true } },
          ],
          [
            "Print",
            data[0],
            customTooltipGoogleCharts(
              "Print",
              data[0],
              parseInt(data[0]) +
                parseInt(data[1]) +
                parseInt(data[2]) +
                parseInt(data[3])
            ),
          ],
          [
            "Digital",
            data[1],
            customTooltipGoogleCharts(
              "Digital",
              data[1],
              parseInt(data[0]) +
                parseInt(data[1]) +
                parseInt(data[2]) +
                parseInt(data[3])
            ),
          ],
          [
            "TV News",
            data[3],
            customTooltipGoogleCharts(
              "TV News",
              data[3],
              parseInt(data[0]) +
                parseInt(data[1]) +
                parseInt(data[2]) +
                parseInt(data[3])
            ),
          ],
          [
            "Radio & Podcast ",
            data[2],
            customTooltipGoogleCharts(
              "Radio & Podcast ",
              data[2],
              parseInt(data[0]) +
                parseInt(data[1]) +
                parseInt(data[2]) +
                parseInt(data[3])
            ),
          ],
        ]}
        options={{
          pieHole: 0.4,
          pieSliceText: "none",
          tooltip: { showColorCode: true, isHtml: true },
          colors: colorArray,
          chartArea: {
            left: 70,
            top: 10,
            bottom: 10,
            width: "100%",
            height: "100%",
          },
          legend: {
            position: "right",
            alignment: "center",
            textStyle: { color: "black", fontSize: 14 },
          },
        }}
      />
    </div>
  );
};

export default DonutChart;
